import ContactForm from './components/ContactForm'

const HelpCentre = (): JSX.Element => {
  return (
    <div className="w-full">

      {/* Content */}
      <div className="container max-w-4xl mt-20 mx-auto px-4 sm:px-8 mb-12">

          {/* Form */}
          <section id="contact-us">
            <div className="text-lg max-w-prose mx-auto">
              <h1>
                <span className="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                  Get In Touch
                </span>
              </h1>
            </div>
            <div className="space-y-6 lg:px-0 lg:col-span-9 my-8">
              <ContactForm />
            </div>
          </section>

        </div>
      </div>

  )
}

export default HelpCentre;